module.exports = __webpack_public_path__ + "img/1103.0b0e7f8b.png";